function getUnreadCount(callback: (unreadCount: number) => void) {
  window?.Intercom?.('onUnreadCountChange', callback);
}

function onHide(callback: () => void) {
  window?.Intercom?.('onHide', callback);
}

function onShow(callback: () => void) {
  window?.Intercom?.('onShow', callback);
}

function hideChatMessenger() {
  window?.Intercom?.('hide');
}

function openChatMessenger() {
  window?.Intercom?.('show');
}

function showSpaceInChat(spaceName: string) {
  window?.Intercom?.('showSpace', spaceName);
}

function setupChat(app_id: string | undefined) {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  // This code is provided by Intercom and was minified.
  const w = window;
  const ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator' as any);
    ic('update', w.intercomSettings);
  } else {
    const d = w.document;
    const i: any = function (...args: unknown[]) {
      i.c(args);
    };
    i.q = [];
    i.c = function (args: any) {
      i.q.push(args);
    };
    w.Intercom = i;
    const l = function () {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://widget.intercom.io/widget/${app_id}`;
      const x = d.getElementsByTagName('script')[0];
      x.parentNode?.insertBefore(s, x);
    };
    if (document?.readyState === 'complete') {
      l();
    } else if ((<any>window).attachEvent) {
      (<any>window).attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
  /* eslint-enable @typescript-eslint/no-explicit-any */
}

function bootUpChat(config: Window['intercomSettings']) {
  window?.Intercom?.('boot', {
    ...config,
  });
}

function shutdownChat() {
  window?.Intercom?.('shutdown');
}

function showDefaultLauncher() {
  window?.Intercom?.('update', {
    hide_default_launcher: false,
  });
}

function hideDefaultLauncher() {
  window?.Intercom?.('update', {
    hide_default_launcher: true,
  });
}

function updateChat(config: Partial<Window['intercomSettings']>) {
  window?.Intercom?.('update', config);
}

export {
  bootUpChat,
  getUnreadCount,
  hideChatMessenger,
  onHide,
  onShow,
  openChatMessenger,
  setupChat,
  shutdownChat,
  showDefaultLauncher,
  showSpaceInChat,
  hideDefaultLauncher,
  updateChat,
};
